import "../../Components/Page/Page.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";


const DeRisking: React.FC = () => {
    return (
        <div className="sectionContainer">
            <SecHeader title="De-Risking" />
            <SubSection isSplit={false}>
                <div className="description-container">
                    <b>Tariff-Proofing​​</b>
                    <p>
                        <ul>
                            <li>ICE GEMS is “Tariff – Proof” since we encourage producing new engines and parts in all countries</li>
                            <li>We are U.S. made, owned, and IP-controlled, with 100% in-house product production</li>
                            <li>We are predicted to give shareholders their investment amounts or more in dividends in the next 5-6 years</li>
                        </ul>
                    </p>{" "}
                    <b>Policy-Proofing​​</b>
                    <p>
                        <ul>
                            <li>ICE GEMS is “Policy – Proof” since ELF-Tech improves energy resilience, jobs, environmental impacts, climates, manufacturing, tech leadership, and public Policies</li>
                        </ul>
                    </p>{" "}
                    <b>Future-Proofing​​</b>
                    <p>
                        <ul>
                            <li>ELF-Tech engines can (a) uses exiting fuels more cleanly and efficiently, and (b) be used to retrofit exiting vehicles, saving jobs and factories, so we comply with short term policies​</li>
                            <li>As new Net-0-CO2 fuels come, ELF-Tech offers the best ways to improve environmental impacts, climates, and jobs, so ICE GEMS is “Future-Proof” for the next 50 years ​​</li>
                        </ul>
                    </p>{" "}
                    
                </div>
            </SubSection>
        </div>
    );
};

export default DeRisking;